document.addEventListener('DOMContentLoaded', () => {
  const overlayMenu = document.getElementById('overlayMenu');
  const hamBurgerMenu = document.getElementById('hamburger-menu-icon');
  const close = document.getElementById('hamburger-menu-close-icon');
  const cartIcons = document.querySelectorAll('.cart-icon');

  // Handle cart icon clicks to open cart drawer using global function
  cartIcons.forEach((cartIcon) => {
    cartIcon.addEventListener('click', () => {
      if (window.toggleCartDrawer) {
        window.toggleCartDrawer(true);
      }
    });
  });

  // Handle hamburger menu toggle
  hamBurgerMenu.addEventListener('click', function () {
    console.log('Hamburger menu clicked');
    overlayMenu.classList.toggle('-translate-y-full');
    overlayMenu.classList.toggle('translate-y-0');
    document.body.style.overflow = 'hidden';
    if (overlayMenu.classList.contains('translate-y-0')) {
      document.body.style.overflowY = 'animate';
    } else {
      document.body.style.overflowY = 'visible';
    }
  });

  // Handle hamburger menu close button
  close.addEventListener('click', () => {
    overlayMenu.classList.toggle('-translate-y-full');
    overlayMenu.classList.toggle('translate-y-0');
    document.body.style.overflow = '';

    if (overlayMenu.classList.contains('translate-y-0')) {
      document.body.style.overflowY = 'animate';
    } else {
      document.body.style.overflowY = 'visible';
    }
  });

  let lastScrollY = window.scrollY;
  let isAtTop = window.scrollY === 0;

  window.addEventListener('scroll', () => {
    const navbar = document.querySelector('.navbar-animation');
    const currentScrollY = window.scrollY;

    // Check if we're at or very near the top (within 5px)
    const approachingTop = currentScrollY < 5;

    if (approachingTop) {
      // When at or near the top, always show navbar
      navbar.classList.remove('animate');
    } else if (currentScrollY > lastScrollY) {
      // Scrolling down (away from top)
      navbar.classList.add('animate');
    } else {
      // Scrolling up (toward top)
      navbar.classList.remove('animate');
    }

    lastScrollY = currentScrollY;
  });
});
